import { createI18nText } from '../../functions';
var stationSelectionText = createI18nText({
    he: {
        result: 'נמצאו :number תחנות',
        stationInfo: {
            closed4more: 'התחנה סגורה להזמנות נוספות',
            area: 'אזור',
            address: 'כתובת',
            directions: 'הוראות הגעה',
            contactName: 'שם איש הקשר',
            contactNumber: 'טלפון איש הקשר',
            hours: 'שעות פעילות',
            accessible: 'נגישות לנכים',
            closed: 'התחנה סגורה',
            appt: '(בתיאום מראש)',
            yes: 'כן',
            no: 'לא'
        }
    },
    en: {
        result: ':number stations were found',
        stationInfo: {
            closed4more: 'The station is closed to additional orders',
            area: 'Area',
            address: 'Address',
            directions: 'Directions',
            contactName: "Station Manager's Name",
            contactNumber: "Station Manager's Number",
            hours: 'Opening Hours',
            accessible: 'Accessibility',
            closed: 'Closed',
            appt: '(By appointment only)',
            yes: 'Yes',
            no: 'No'
        }
    }
});
export default stationSelectionText;
//# sourceMappingURL=stationSelectionText.js.map